import { render, staticRenderFns } from "./64.vue?vue&type=template&id=475e8d87&scoped=true&"
import script from "./64.vue?vue&type=script&lang=js&"
export * from "./64.vue?vue&type=script&lang=js&"
import style0 from "./64.vue?vue&type=style&index=0&id=475e8d87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475e8d87",
  null
  
)

export default component.exports